import { create } from 'zustand';

// Key for localStorage
const PASSCODE_UNLOCK_KEY = 'dev_passcode_unlocked';

// Helper to get unlock status from localStorage
const getStoredUnlockStatus = () => {
  try {
    const storedStatus = localStorage.getItem(PASSCODE_UNLOCK_KEY);
    return storedStatus === 'true';
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return false;
  }
};

// Helper to update localStorage
const updateStoredUnlockStatus = (isUnlocked) => {
  try {
    localStorage.setItem(PASSCODE_UNLOCK_KEY, isUnlocked.toString());
  } catch (error) {
    console.error('Error updating localStorage:', error);
  }
};

const usePasscodeStore = create((set) => ({
  // Initial state based on localStorage
  isUnlocked: getStoredUnlockStatus(),

  // Unlock the app with correct passcode
  unlock: (passcode) => {
    const correctPasscode = 'dononn';
    if (passcode === correctPasscode) {
      set({ isUnlocked: true });
      updateStoredUnlockStatus(true);
      return true;
    }
    return false;
  },

  // Lock the app (for testing purposes)
  lock: () => {
    set({ isUnlocked: false });
    updateStoredUnlockStatus(false);
  },

  // Reset unlock status
  reset: () => {
    set({ isUnlocked: false });
    try {
      localStorage.removeItem(PASSCODE_UNLOCK_KEY);
    } catch (error) {
      console.error('Error resetting localStorage:', error);
    }
  }
}));

export default usePasscodeStore;
